

//Pusher.logToConsole = true;

var pusher = new Pusher('2a40ff40b2022ff75c5f', {
    cluster: 'eu'
});

export default pusher